import { Utils } from './utils';
import { forceCloseHamburger } from './animation';

// ================================================================
// スクロール関連機能
// ================================================================

// -----------------------------------------------
// ヘッダー表示制御
// -----------------------------------------------
export function initHeaderVisibility() {
  const header = document.querySelector('.js-header');
  
  if (!header) {
    return;
  }

  if (typeof ScrollTrigger === 'undefined') {
    console.warn('ScrollTrigger is not loaded');
    return;
  }

  try {
    ScrollTrigger.create({
      trigger: 'body',
      start: 'top top-=100',
      end: 'bottom bottom-=10',
      markers: false,
      toggleClass: { targets: '.js-header', className: 'is-visible' },
      onEnter: () => header.classList.add('is-visible'),
      onLeaveBack: () => header.classList.remove('is-visible'),
    });
  } catch (error) {
    console.error('Failed to initialize header visibility:', error);
  }
}

// -----------------------------------------------
// スムーズスクロール
// -----------------------------------------------
export function initSmoothScroll() {
  const anchors = document.querySelectorAll('a[href*="#"]');
  
  if (!anchors.length) {
    return;
  }

  anchors.forEach((anchor) => {
    // 目次プラグインのアンカーの場合はスキップ
    if (anchor.closest('#ez-toc-container')) {
      return;
    }

    anchor.addEventListener('click', (event) => {
      if (Utils.isInPageLink(event)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
                // ドロワーが開いている場合は強制的に閉じる
        forceCloseHamburger();
        
        Utils.movePosition(event.currentTarget);
      }
    });
  });
}

// -----------------------------------------------
// CTAポップアップ制御
// -----------------------------------------------
export function initCtaPopup() {
  // 必要な要素を取得
  const popup = document.querySelector('.js-cta-popup');
  const closeBtn = document.querySelector('.js-cta-close');
  const ctaContact = document.querySelector('.js-cta-contact');

  // 必要な要素がない場合は終了
  if (!popup || !closeBtn) return;

  // ポップアップを閉じたかどうか
  let isClosed = false;

  // ページの種類を判定
  const isServicePage = document.querySelector('[id^="service-"]') !== null;
  const isTopPage = document.body.classList.contains('home') || 
                    document.body.classList.contains('front-page') ||
                    window.location.pathname === '/' ||
                    window.location.pathname === '/index.php';
  const isMobile = Utils.isMobile();

  // ポップアップを表示するかどうか
  const showPopup = () => {
    // 閉じられている場合は非表示
    if (isClosed) {
      popup.classList.remove('is-visible');
      return;
    }

    // サービスページのトップは非表示
    // if (window.scrollY === 0 && isServicePage) {
    //   popup.classList.remove('is-visible');
    //   return;
    // }

    // それ以外は表示
    popup.classList.add('is-visible');
  };

  // トップページFV内での位置調整
  const adjustTopFvPosition = () => {
    const isAtTop = (window.scrollY || window.pageYOffset) === 0;
    // if (isTopPage && !isMobile && isAtTop) {
    if (isTopPage && isAtTop) {
        document.body.classList.add('in-top-fv');
    } else {
      document.body.classList.remove('in-top-fv');
    }
  };

  // 閉じるボタンをクリックしたとき
  closeBtn.addEventListener('click', () => {
    popup.classList.remove('is-visible');
    isClosed = true;
  });

  // ScrollTriggerがない場合は終了
  if (typeof ScrollTrigger === 'undefined') return;

  try {
    // スクロール位置に応じて表示/非表示を切り替え
    ScrollTrigger.create({
      trigger: 'body',
      start: 'top top',
      end: '+=1',
      onUpdate: () => {
        showPopup();
        adjustTopFvPosition();
      }
    });

    // CTAセクションに入ったら非表示、出たら表示
    if (ctaContact) {
      ScrollTrigger.create({
        trigger: ctaContact,
        start: 'top bottom-=100',  // CTAセクションの上部が画面下部に来た時
        end: 'bottom bottom-=100', // CTAセクションの下部が画面下部に来た時
        onEnter: () => popup.classList.remove('is-visible'),
        onLeaveBack: () => showPopup(),
      });
    }

    // 初期表示
    showPopup();
    adjustTopFvPosition();

  } catch (error) {
    console.error('Failed to initialize CTA popup scroll trigger:', error);
  }
} 